import { stringify } from '@angular/compiler/src/util';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Route, Router, RouterModule } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
declare var gapi: any;
declare var FB: any;
import { ViewChild, ElementRef } from '@angular/core'
import { NgZone } from '@angular/core';
import { LoginService } from '../../login-service';
import { SocialLogins } from '../../sociallogins';
import { switchAll } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-dashboard',
  templateUrl: 'login.component.html',
  providers: [DatePipe]
})
export class LoginComponent implements OnInit {
  @ViewChild('loginRef', { static: true }) loginElement: ElementRef;
  // validateUserDetails:any;
  form: FormGroup = new FormGroup({});
  emailID: string;
  password: string;
  tabtype: string;
  displayerror: boolean = true;
  displayerror1: boolean = true;
  errorMessage: string;
  IsSocialLogin:boolean=false;
  displayloginscreen:boolean=false;
  userTname:string;
  // NewPassword:string;
  loginForm: FormGroup;
  submitted: boolean = false;
  usersList: any;
  auth2: any;
  show: boolean;
  Name: any;
  toastr: any;
  typeOfLogin: boolean = false;
  linkedInToken: string;
  linkdinList: any;
  accessToken: string;
  linkdinProfileData: any;
  linkdinEmail: any;

  loggedinas: string;
  tabValue = 0;
  emaill: any;
  subscriptionList: any;
  todaysDate:any;
  subscriptionid: any;
  constructor(private aRoute: ActivatedRoute,private datepipe:DatePipe, private zone: NgZone, private router: Router, private formBuilder: FormBuilder, private loginService: LoginService, private socialLogins: SocialLogins) {
    this.userTname = '1';
    this.tabtype = 'Initiator';

    this.GetUsers();
  }
  ngOnInit(): void {
    var date=new Date();
   
    this.todaysDate = this.datepipe.transform(date, 'yyyy-MM-dd');
    console.log(this.todaysDate)
    this.GetUsers();
    this.GetSubscriptions();
    this.loggedinas = localStorage.getItem('LOGGEDINAS');
    if (this.loggedinas == 'Initiator') {
      this.tabValue = 1;

    } else {
      this.tabValue = 2;
    }
    localStorage.setItem('PROCESS', 'login');
    localStorage.removeItem("SIGNEDUPAS")

    this.linkedInToken = this.aRoute.snapshot.queryParams["code"];

    this.loginForm = this.formBuilder.group({

      email: ['', [Validators.required, Validators.email, Validators.maxLength(100)]],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });

    this.linkedInToken = this.aRoute.snapshot.queryParams["code"];

    const json = {
      code: this.linkedInToken,
      clientid: '86159q6mw4bpp9',
      secretid: 'oaViGJ6wshIbtnS0',
      scope: 'r_liteprofile+r_emailaddress',
    }
    let code = this.linkedInToken;
    let clientid = '86159q6mw4bpp9';
    let secretid = 'oaViGJ6wshIbtnS0';
    this.loginService.GetOauth(json).subscribe(data => {

      data = JSON.parse(data['_body']);
      this.linkdinList = JSON.parse(JSON.stringify(data));

      this.accessToken = this.linkdinList.access_token;

      this.loginService.GetProfileData(this.accessToken).subscribe(data => {

        data = JSON.parse(data['_body']);
        this.linkdinProfileData = JSON.parse(JSON.stringify(data));

        this.loginService.GetEmail(this.accessToken).subscribe(data => {

          data = JSON.parse(data['_body']);
          this.linkdinEmail = JSON.parse(JSON.stringify(data));

          let userType: string;
          if (this.tabtype == 'Initiator') {
            userType = "1";
          }
          else {
            userType = "2";
          }

          this.socialLogins.usernameparm = this.linkdinProfileData.firstName.localized.en_US + " " + this.linkdinProfileData.lastName.localized.en_US;
          this.socialLogins.emailparm = this.linkdinEmail.elements[0]["handle~"].emailAddress;

          this.socialLogins.firstnameparm = this.linkdinProfileData.firstName.localized.en_US;
          this.socialLogins.lastnameparm = this.linkdinProfileData.lastName.localized.en_US;
          this.socialLogins.usertypeidparm = userType;
          this.socialLogins.passwordparm = "";
          this.socialLogins.socialusersparm = "LinkedIn";
          this.typeOfLogin = true;;

          this.SaveUserWithSocial();
        });

      });
    });

    //google integration
    this.googleInitialize();
    //facebook integration
    (window as any).fbAsyncInit = function () {
      FB.init({
        appId: '904674230322026',
        cookie: true,
        xfbml: true,
        version: 'v3.1'
      });
      FB.AppEvents.logPageView();
    };
    (function (d, s, id) {

      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

    //this.googleInitialize();
  }
  //form values assignment
  get f() { return this.loginForm.controls; }

  
  googleInitialize() {
    window['googleSDKLoaded'] = () => {
      window['gapi'].load('auth2', () => {
        this.auth2 = window['gapi'].auth2.init({
          client_id: '754184839525-t3con2lvf5513oekl5k81mpivve5868f.apps.googleusercontent.com',
          cookie_policy: 'single_host_origin',
          scope: 'profile email'
        });
        this.prepareLogin();
      });
    }
    (function(d, s, id){
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {return;}
      js = d.createElement(s); js.id = id;
      js.src = "https://apis.google.com/js/platform.js?onload=googleSDKLoaded";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'google-jssdk'));
  }

  prepareLogin() {
    console.log("in google prepare login")
    this.auth2.attachClickHandler(this.loginElement.nativeElement, {},
      (googleUser) => {
        let profile = googleUser.getBasicProfile();
        console.log(profile)
        this.show = true;
        this.Name = profile.getName();
        // let userType=this.tabtype;
        let userType: string;
        if (this.tabtype == 'Initiator') {
          userType = "1";
        }
        else {
          userType = "2";
        }
        this.socialLogins.usernameparm = profile.getName();
        this.socialLogins.emailparm = profile.getEmail();
        this.socialLogins.firstnameparm = profile.getGivenName();
        this.socialLogins.lastnameparm = profile.getFamilyName();
        this.socialLogins.usertypeidparm = userType;
        this.socialLogins.passwordparm = "";
        this.socialLogins.isverifiedparam = "n";
        this.socialLogins.issubscribedparam = "n";
        this.socialLogins.socialusersparm = "google";
        this.typeOfLogin = true;;
        console.log(this.socialLogins)
        this.SaveUserWithSocial();

      }, (error) => {
        alert(JSON.stringify(error, undefined, 2));
      });
  }
  SaveUserWithSocial() {
this.GetUsers();
    let validateUser = this.usersList.filter(x => x.email.toLowerCase().toString() === this.socialLogins.emailparm.toLowerCase().toString());
    if(validateUser.length>0)
    {
    var subList=this.subscriptionList.filter(x=>x.collaborator_id==validateUser[0].id || x.initiator_id==validateUser[0].id)
    console.log(subList)
    if(subList.length>0){
      this.subscriptionid=subList[0].id;
    }
    else{
      this.subscriptionid=0;
    }
    }
    
    if (validateUser.length > 0) {
      
      this.socialLogins.userid = validateUser[0].id;
      this.socialLogins.emailparm = validateUser[0].email;
      this.socialLogins.passwordparm = validateUser[0].password;
      this.socialLogins.usertypeidparm = validateUser[0].user_type_id;
      localStorage.setItem('userType',validateUser[0].user_type_id)
      if (this.socialLogins.passwordparm == "") {
        this.displayloginscreen = true;

        this.zone.run(() => {
          this.router.navigate(['/passwordchange', this.socialLogins.userid]);
        });
      }

      else {
        if (subList.length==0 || this.todaysDate>subList[0].end_date.split('T')[0] ) {
          this.zone.run(() => {
          this.router.navigate(['/subscribe', validateUser[0].id, this.tabValue,this.subscriptionid]);
          });
        }
        else {
          if(validateUser[0].profilestatus=='n'){
            this.zone.run(() => {
              this.router.navigate(['/profilesetup',validateUser[0].id, validateUser[0].user_type_id]);
            });
          }
          else{
          localStorage.setItem('USERID', validateUser[0].id);
          if (this.tabtype === 'Initiator') {
            localStorage.setItem('LOGGEDINAS', validateUser[0].user_name);
            localStorage.setItem('userType', validateUser[0].user_type_id);
            
            this.zone.run(() => {
              this.router.navigate(['/initatorcollabo/0/0']);
            });
          }
         
        
          else if (this.tabtype === 'Collaborator') {
            localStorage.setItem('LOGGEDINAS', validateUser[0].user_name);
            localStorage.setItem('userType', validateUser[0].user_type_id);
            this.zone.run(() => {
              this.router.navigate(['/collabo']);
            });

          }
        }
        }
      }
    }
    else {
      var userType;
      if (this.tabtype == 'Initiator') {
        userType = "1";
      }
      else {
        userType = "2";
      }

      localStorage.setItem('userType', userType);
      this.loginService.SaveUsers(this.socialLogins).subscribe(data => {
        this.loginService.GetUsers(this.userTname).subscribe(data => {
          data = JSON.parse(data['_body']);
          this.usersList = JSON.parse(JSON.stringify(data));
          let validateUser = this.usersList.filter(x => x.email.toLowerCase().toString() === this.socialLogins.emailparm.toLowerCase().toString());
          if (validateUser.length > 0) {
            this.socialLogins.userid = validateUser[0].id;
            this.socialLogins.emailparm = validateUser[0].email;
            this.socialLogins.passwordparm = validateUser[0].password;
            this.zone.run(() => {
              this.router.navigate(['/passwordchange', this.socialLogins.userid]);
            });

          }
        });
      });
    }
  }
  /*
  facebook integration
  */
  submitLogin() {

    // FB.login();
    FB.login((response) => {
      if (response.authResponse) {
        this.toastr.successToastr('login successful', 'Success!');
      }
      else {
      }
    });
  }
  /*
changing tab to Initiator/Collaborator
  */
  TabChanging(type) {
    this.tabtype = type;
  }
  ClearFields() {
    this.emailID = '';
    this.password = '';
  }
  GetSubscriptions(){
    this.loginService.GetSubscriptions().subscribe(data=>{
      data = JSON.parse(data['_body']);
      this.subscriptionList=JSON.parse(JSON.stringify(data));
      console.log(this.subscriptionList)
    })
  }
  //google button
  //Validating email address and email password
  SignIn() {

    let userType = this.tabtype;
    if (this.loginForm.invalid) {
      this.submitted = true;
      return;
    }
    else
      this.submitted = false;
    this.emailID = this.loginForm.value.email;
    this.password = this.loginForm.value.password;

    if (this.usersList.length > 0) {
      let validateUser = this.usersList.filter(x => x.email.toLowerCase().toString() === this.emailID.toLowerCase().toString() && x.password.toLowerCase().toString() == this.password.toLowerCase().toString() && x.user_type.toLowerCase().toString() === userType.toLowerCase().toString());
      console.log(validateUser);
      // var subList=this.subscriptionList.filter(x=>x.collaborator_id==validateUser[0].id || x.initiator_id==validateUser[0].id)
      // console.log(subList)
      // if(subList.length>0){
      //   this.subscriptionid=subList[0].id;
      // }
      // else{
      //   this.subscriptionid=0;
      // }
      // console.log(subList[0].end_date.split('T')[0])
      // console.log( this.todaysDate>subList[0].end_date.split('T')[0] )
      if (validateUser.length > 0) {
        var subList=this.subscriptionList.filter(x=>x.collaborator_id==validateUser[0].id || x.initiator_id==validateUser[0].id)
        console.log(subList)
        if(subList.length>0){
          this.subscriptionid=subList[0].id;
        }
        else{
          this.subscriptionid=0;
        }
        if(validateUser[0].isverified=="y")
      {
        

        if (subList.length==0 || this.todaysDate>subList[0].end_date.split('T')[0] ) {
          
          localStorage.setItem('USERID', validateUser[0].id);
          if (userType === 'Initiator') {
            localStorage.setItem('LOGGEDINAS', userType);
            localStorage.setItem('userType', validateUser[0].user_type_id);
            this.router.navigate(['/subscribe', validateUser[0].id, validateUser[0].user_type_id,this.subscriptionid]);
          }
          else if (userType === 'Collaborator') {
            localStorage.setItem('LOGGEDINAS', userType);
            localStorage.setItem('userType', validateUser[0].user_type_id);
            this.router.navigate(['/subscribe', validateUser[0].id, validateUser[0].user_type_id,this.subscriptionid]);
          }
        }
        else {
          this.loginService.showSuccess("Loggedin Successfuly", "");
          localStorage.setItem('USERID', validateUser[0].id);
          if(validateUser[0].profilestatus=="y")
          {
          if (userType === 'Initiator') {
            localStorage.setItem('LOGGEDINAS', userType);
            localStorage.setItem('userType', validateUser[0].user_type_id);
            this.router.navigate(['/initatorcollabo/0/0']);
          }
          else if (userType === 'Collaborator') {
            localStorage.setItem('LOGGEDINAS', userType);
            localStorage.setItem('userType', validateUser[0].user_type_id);
            this.router.navigate([`/collabo`]);
          }
        }
        else{
          this.router.navigate(['/profilesetup', validateUser[0].id, validateUser[0].user_type_id]);
        }
        }
      }
    
      else {
        setTimeout(() => {
          this.errorMessage = "Please verify your mail first"
          this.loginService.SendMail(validateUser[0].email,validateUser[0].id,"loginverify").subscribe(data=>{console.log(data)});
          this.ClearFields();

        }, 1000);
      }
      }
      else{
        this.errorMessage = "User does not exist in cloud collabo.";
      }
    }
    else {
      this.errorMessage = "Server Not Conneted."
    }
  }
  //Retrieving all users by usertype
  GetUsers() {
    this.loginService.GetUsers(this.userTname).subscribe(data => {
      data = JSON.parse(data['_body']);
      this.usersList = JSON.parse(JSON.stringify(data));
      console.log(this.usersList);
    });
  }
  //Login with linkdin
  loginLinkdin() {
    window.location.href = 'https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=86159q6mw4bpp9&scope=r_liteprofile&state=123456&redirect_uri=http://localhost:4200';
    this.linkedInToken = this.aRoute.snapshot.queryParams["code"];
  }
  navigate() {
    localStorage.setItem('USERCREATEDBY', 'user');
  }
}
